// extracted by mini-css-extract-plugin
module.exports = {"metadata":"BaseInThisSnapCard_metadata__fCYx7","clickableStyle":"BaseInThisSnapCard_clickableStyle__h7kTR","footerCard":"BaseInThisSnapCard_footerCard__Z_jg_"};